import { render, staticRenderFns } from "./licenses.vue?vue&type=template&id=b92281ca&scoped=true"
import script from "./licenses.vue?vue&type=script&lang=js"
export * from "./licenses.vue?vue&type=script&lang=js"
import style0 from "./licenses.vue?vue&type=style&index=0&id=b92281ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b92281ca",
  null
  
)

export default component.exports